



































































import { Component, Prop, Vue } from "vue-property-decorator";
import { RelatedReferralModel } from "@/types/aznconnect_api";
import ReferralIcon from "@/components/ReferralIcon.vue";

@Component({
  components: {
    "referral-icon": ReferralIcon,
  },
})
export default class DetailPaneRelatedReferrals extends Vue {
  @Prop({ default: null })
  currentReference!: string;

  @Prop({ default: null })
  relatedReferrals!: RelatedReferralModel[];

  private getBorderCssClasses(referenceId: string): string {
    var cssClasses = "borderDiv";
    if (referenceId === this.currentReference) {
      cssClasses += " currentMessage";
    }

    return cssClasses;
  }

  private messageTypeToDisplay(
    messageType: string,
    urgencyCode: string,
  ): string {
    var display = "";
    if (messageType === "Triage") {
      display = "Spoedverwijzing (HAP)";
    } else if (messageType === "ESpoed") {
      if (urgencyCode === "H1" || urgencyCode === "1") {
        display = "Rit informatie (helicopter)";
      } else {
        display = "Rit informatie (ambulance)";
      }
    } else if (messageType === "SelfReferrer") {
      display = "Zelfverwijzing";
    } else {
      display = "Onbekend message type";
    }

    return display;
  }

  private navigateToRelatedReferral(
    relatedReferralModel: RelatedReferralModel,
  ) {
    var me = this;
    if (relatedReferralModel !== null && relatedReferralModel !== undefined) {
      if (relatedReferralModel.ReferenceId !== me.currentReference) {
        me.$router.push({
          name: me.$router.currentRoute.name,
          params: {
            cluster: "-",
            department: "-",
            referralId: relatedReferralModel.ReferenceId || "",
          },
        });
      }
    }
  }
}
